<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.emailTemplates.addNewEmailTemplate') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/szablony-email')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('settings.emailTemplates.addNewEmailTemplate') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form :class="{ 'is-loading': !allDataLoaded }">
      <d-card class="mb-5">
        <d-tabs v-sticky-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="email-template-new-form" tag="form">
              <div class="form-group">
                <label for="language-id">
                  {{ $t('settings.emailTemplates.language') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="language-id"
                  v-slot="{ errors }">
                  <d-form-select
                    v-model="languageID"
                    :state="errors.length ? 'invalid' : null"
                    :options="languagesOptions" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.footerImage') }}:
                </label>

                <file-input
                  :onChange="setFooterImage"
                  id="inputFileFooterImage" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.footerUrl') }}:
                </label>

                <validation-provider
                  rules="valid-url"
                  name="footer-url"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="footerUrl" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.companyName') }}:
                </label>

                <d-input
                  v-model="companyName" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.address1') }}:
                </label>

                <d-input
                  v-model="address1" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.address2') }}:
                </label>

                <d-input
                  v-model="address2" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.url') }}:
                </label>

                <validation-provider
                  rules="valid-url"
                  name="url"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="url" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.email') }}:
                </label>

                <validation-provider
                  rules="email"
                  name="email"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="email" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.phone') }}:
                </label>

                <d-input
                  v-model="phone" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.facebookUrl') }}:
                </label>

                <validation-provider
                  rules="valid-url"
                  name="facebook-url"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="facebookUrl" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.youtubeUrl') }}:
                </label>

                <validation-provider
                  rules="valid-url"
                  name="youtube-url"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="youtubeUrl" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.linkedinUrl') }}:
                </label>

                <validation-provider
                  rules="valid-url"
                  name="linkedin-url"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="linkedinUrl" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.emailTemplates.instagramUrl') }}:
                </label>

                <validation-provider
                  rules="valid-url"
                  name="facebook-url"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="instagramUrl" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'email-template-new',
  computed: {
    allDataLoaded () {
      return this.loadedLanguages;
    },
    languagesOptions () {
      return [{ value: '', text: this.$t('settings.language.chooseLanguage') }].concat(this.languages.map(language => ({
        value: language.id,
        text: language.name
      })));
    }
  },
  data() {
    return {
      languageID: '',
      footerImage: '',
      footerUrl: '',
      companyName: '',
      address1: '',
      address2: '',
      url: '',
      email: '',
      phone: '',
      facebookUrl: '',
      youtubeUrl: '',
      linkedinUrl: '',
      instagramUrl: '',
      // helper fields
      loadedLanguages: false,
      languages: [],
      loadError: false
    };
  },
  mounted () {
    this.loadAdditionalData();
  },
  methods: {
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/languages/items',
        loadedKey: 'loadedLanguages',
        outputKey: 'languages',
        errorKey: 'loadError'
      });
    },
    setFooterImage (event) {
      this.footerImage = event.target.files[0];
    },
    validateForm () {
      FormUtils.validate(this.$refs['email-template-new-form'], this.submitForm);
    },
    submitForm () {
      let imageFields = false;

      let formDataToSend = {
        language_id: this.languageID,
        footer_url: this.footerUrl,
        company_name: this.companyName,
        address_1: this.address1,
        address_2: this.address2,
        url: this.url,
        email: this.email,
        phone: this.phone,
        facebook_url: this.facebookUrl,
        youtube_url: this.youtubeUrl,
        linkedin_url: this.linkedinUrl,
        instagram_url: this.instagramUrl
      };

      if (this.footerImage) {
        formDataToSend.footer_image = this.footerImage;
        imageFields = ['footer_image'];
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/email-templates/store',
        formData: formDataToSend,
        successTitle: this.$t('settings.emailTemplates.addEmailTemplateSuccessTitle'),
        successText: this.$t('settings.emailTemplates.addEmailTemplateSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.emailTemplates.addEmailTemplateErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/szablony-email')
        }
      }, imageFields);
    }
  }
};
</script>

<style lang="scss" scoped>
form.is-loading {
  opacity: .25;
  pointer-events: none;
}
</style>
